import React from 'react';
import { withTranslations, TranslateFunction } from 'react-utilities';
import { Link } from 'react-style-guide';
import {
  TCatalog,
  TAvatarShopHomepageRecommendationsCarousel
} from './AvatarShopHomepageRecommendationsCarouselTypes';
import ItemCard from '../components/ItemCard';
import itemCardUtils from '../utils/itemCardUtils';
import urlConfigs from '../constants/urlConfigs';
import translationConfig from '../translation.config';

export const AvatarShopHomepageRecommendationsCarousel = ({
  recommendedItems,
  translate
}: {
  recommendedItems: Array<TCatalog>;
  translate: TranslateFunction;
}): JSX.Element | null => {
  if (recommendedItems === undefined || recommendedItems.length < 1) {
    return <div />;
  }
  return (
    <React.Fragment>
      <div
        className='avatar-shop-homepage-recommendations-container'
        id='populated-avatar-shop-homepage-recommendations'>
        <div className='avatar-shop-homepage-carousel-title'>
          <Link url={urlConfigs.avatarShopRecommendationUrl} className='font-header-1'>
            {translate('Label.AvatarItemsForYou')}
          </Link>
          <Link url={urlConfigs.avatarShopRecommendationUrl} className='see-all-link-icon'>
            {translate('Action.SeeAll')}
          </Link>
        </div>
        <div className='avatar-shop-homepage-carousel'>
          {recommendedItems.map((item: TCatalog) => {
            return (
              // eslint-disable-next-line react/jsx-key
              <ItemCard
                id={item.itemId}
                name={item.name}
                type={item.itemType}
                creatorName={item.creatorName}
                creatorType={item.creatorType}
                creatorTargetId={item.creatorId}
                price={item.price || 0}
                lowestPrice={item.lowestPrice || -1}
                unitsAvailableForConsumption={item.numberRemaining || 0}
                itemStatus={item.itemStatus}
                itemStatusLabels={itemCardUtils.mapItemStatusIconsAndLabels(item)}
                priceStatus={item.noPriceStatus}
                premiumPricing={item.premiumPrice || -1}
                itemRestrictions={item.itemRestrictions}
                itemRestrictionLabels={itemCardUtils.mapItemRestrictionIcons(item)}
                translate={translate}
                url={itemCardUtils.getItemLink(item.itemId, item.name, item.itemType)}
              />
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslations<{ recommendedItems: Array<TCatalog> }>(
  AvatarShopHomepageRecommendationsCarousel,
  translationConfig
) as TAvatarShopHomepageRecommendationsCarousel;
